<template>
    <div class="modal-user-info" @click.prevent="onClose">
        <div class="user-info-modal-box" @click.stop="">
            <div class="user-info-header-box">
                <div class="user-info-title-box">
                    {{ $t("common.Personal_Information") }}
                </div>
            </div>
            <div class="user-info-body">
                <div
                    class="user-info-headbg ico ico-head-bg-big"
                    :style="'transform: scale(1.3);'"
                >
                    <div
                        class="user-head ico"
                        :class="'ico-avatar-' + headId"
                    ></div>
                </div>
                <div class="user-info-name" v-if="!isFocus">
                    {{ $store.state.user.realUser.nickname }}
                </div>
                <input
                    v-if="isFocus"
                    id="accountInput"
                    type="text"
                    :maxlength="16"
                    :placeholder="$t('tips.Enter_your_user_name')"
                    v-model="userName"
                    @input="onInput()"
                    @focus="focusEvent(true)"
                    @blur="focusEvent(false)"
                    class="user-info-name-input"
                />
                <!-- <div class="user-info-uuid">
                    {{ $store.state.user.realUser.id }}
                </div> -->
                <div class="user-change-head-btn my-btn" @click="changeHead()">
                    {{ $t("common.Change_picture") }}
                </div>
                <div class="user-login-out-btn my-btn" @click="onLogout()">
                    {{ $t("common.Log_out") }}
                </div>
                <div
                    class="user-change-name ico ico-btn-change-name my-btn"
                    @click="onEditUserName()"
                ></div>
                <!-- <div
                    class="user-copy-uuid ico ico-btn-copy my-btn"
                    @click="onCopy()"
                ></div> -->
            </div>
        </div>
        <MessageBox
            v-if="isShowMessageBox"
            :hasBtn="2"
            :title="$t('common.Notification')"
            :body="$t('tips.Are_you_sure_logout')"
            @on-left="isShowMessageBox = false"
            @on-right="logout()"
            :rightText="$t('common.OK')"
            :leftText="$t('common.Cancel')"
        ></MessageBox>
    </div>
</template>
<script>
import ServerManager from "../../interface/server";
import userfun from "../../utils/userFun";
import tools from "../../utils/fun";
import eventConfig from "../../baseConfig/eventConfig";
import MessageBox from "../common/modal_message_box";
export default {
    name: "Modal",
    components: {
        MessageBox,
    },
    props: {},
    data() {
        return {
            userName: "",
            isFocus: false,
            isShowMessageBox: false,
        };
    },
    computed: {
        headId() {
            return userfun.getHeadIdByUrl(
                this.$store.state.user.realUser.avatar
            );
        },
    },
    mounted() {},
    methods: {
        changeHead() {
            this.$emit("on-changehead");
        },
        onEditUserName() {
            this.isFocus = true;
            this.userName = this.$store.state.user.realUser.nickname;
            this.$nextTick(() => {
                document.getElementById("accountInput").focus();
            });
        },

        checkS(str) {
            // 判断字符串是否为数字和字母组合
            var zg = /^[0-9a-zA-Z]{6,16}$/;

            if (!zg.test(str)) {
                return false;
            } else {
                return true;
            }
        },
        focusEvent(e) {
            this.isFocus = e;
            console.log(e);
            if (!this.isFocus) {
                if (this.$store.state.user.realUser.nickname != this.userName) {
                    if (this.checkS(this.userName)) {
                        this.checkName();
                    } else {
                        this.$toast.show(this.$t("tips.nikename_changed_err"));
                    }
                }
            }
        },
        checkName() {
            console.log("checkName");
            tools.setLoadingState(true);
            ServerManager.checkNicknameExist(
                this,
                this.userName,
                (data) => {
                    if (data.data) {
                        this.$toast.show(
                            this.$t("tips.nikename_is_already_in_use")
                        );
                        tools.setLoadingState(false);
                    } else {
                        this.changeName();
                    }
                },
                (error) => {
                    tools.setLoadingState(false);
                    this.$toast.show(error);
                }
            );
        },
        changeName() {
            ServerManager.updateUser(
                this,
                "nickname",
                this.userName,
                (data) => {
                    tools.setLoadingState(false);
                    if (data.result == 1) {
                        this.getUserAction();
                        ServerManager.resetLmName(
                            this,
                            this.userName,
                            () => {},
                            () => {}
                        );
                        this.$toast.show(
                            this.$t("tips.nikename_changed_successfully")
                        );
                    } else {
                        this.$toast.show(this.$t("tips.nikename_changed_err"));
                    }
                },
                (error) => {
                    tools.setLoadingState(false);
                }
            );
        },
        getUserAction() {
            tools.setLoadingState(true);
            ServerManager.getUserInfo(
                this,
                (data) => {
                    tools.setLoadingState(false);
                },
                (error) => {
                    tools.setLoadingState(false);
                }
            );
        },
        onInput() {},
        onCopy() {
            let self = this;
            this.$copyText(this.$store.state.user.realUser.id).then(
                function (e) {
                    self.$toast.show(self.$t("tips.Copy_success"));
                },
                function (e) {
                    console.log(e);
                }
            );
        },
        logout() {
            this.$store.commit("user/clearLogin");
            this.onClose();
        },
        onLogout() {
            this.isShowMessageBox = true;
        },
        onClose() {
            tools.emit(eventConfig.playEffect, "pop");
            this.$emit("on-close");
        },
    },
};
</script>
<style>
@import "../../assets/spritesmith-generated/home.css";
@import "../../assets/css/user.css";
.user-info-body {
    margin-top: 18px;
    height: 659px;
    width: 580px;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
}
.user-info-headbg {
    margin-top: 46px;
    width: 100px;
    height: 100px;
    object-fit: fill;
}
.user-info-name {
    margin-top: 46px;
    width: 258px;
    height: 30px;
    font-size: 28px;
    font-family: Arial;
    font-weight: bold;
    color: #f82e49;
    line-height: 30px;
}
.user-info-name-input {
    margin-top: 46px;
    width: 258px;
    height: 30px;
}
.user-info-uuid {
    margin-top: 46px;
    width: 258px;
    height: 30px;
    font-size: 28px;
    font-family: Arial;
    font-weight: bold;
    color: #a1a1a1;
    line-height: 30px;
}
.user-change-head-btn {
    width: 340px;
    height: 80px;
    background: #f82e49;
    box-shadow: 0px 5px 5px 0px rgba(0, 0, 0, 0.35);
    border-radius: 15px;

    font-size: 30px;
    font-family: Arial;
    font-weight: bold;
    color: #ffffff;
    line-height: 80px;
    text-align: center;
    margin-top: 84px;
}
.user-login-out-btn {
    width: 340px;
    height: 80px;
    background: rgba(0, 0, 0, 0);
    border: 2px solid #f82e49;
    border-radius: 15px;

    font-size: 30px;
    font-family: Arial;
    font-weight: bold;
    color: #f82e49;
    line-height: 80px;
    text-align: center;
    margin-top: 20px;
}
.user-change-name {
    position: absolute;
    right: 75px;
    top: 185px;
}
.user-copy-uuid {
    position: absolute;
    right: 75px;
    top: 262px;
}
.user-head {
    margin-top: 2px;
    margin-left: 2.5px;
}
</style>



// WEBPACK FOOTER //
// src/components/user/rummy_user_info.vue